import type { FeatureManifest } from '../registry.js';
import { albumOff, pendingIncoming } from './badge.js';
import { TradeIcon } from './icon.js';

/**
 * SO-08 sticker trades (SCR-10 trade offer): 1-for-1 between friends, both confirm, no gold,
 * 5 a day. Rail badge = incoming offers waiting; the map hook shows new offers once.
 * Trades are between friends, so they unlock with them (economy.featureUnlocks.friends).
 * They also need the album (`collections` flag): with it off, the badge and map hook stay
 * quiet and the views say the album is paused (one flag per manifest; see albumOff).
 */
export default {
  id: 'trading',
  flag: 'stickerTrades',
  unlock: 'friends',
  online: true,
  art: ['stickers_*'],
  provides: ['trades', 'tradeNew', 'tradeAccept', 'tradeNotice'],
  entry: { order: 45, icon: TradeIcon, label: 'feature.trading.rail', testId: 'rail-trades', open: 'trades', badge: (a) => (albumOff(a) ? null : pendingIncoming(a.services.kv, a.services.now()) || null) },
  mapOrder: 30,
  mapDue: (a) => !albumOff(a) && a.services.sync.status !== 'offline' && !a.session.checked.has('trading'),
  load: () => import('./index.js'),
} satisfies FeatureManifest;
